module.exports = SharedDependencies.React['application'];